import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {  getDDJJUser } from '../../actions/index'
import 'reactjs-popup/dist/index.css';
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF from '../../components/ReactPDF/ReactPDF'





const UserDDJJ = () => {

  const token = localStorage.getItem('token')
  
  const ddjj = useSelector(state => state.ddjj)

  
  const dispatch = useDispatch()

  useEffect(()=>{ 
    dispatch(getDDJJUser(token))
  }, [])

  return (
     <div>
      { ddjj ? 
      <PDFViewer style={{ width: '100%', height: '100vh'}}>
        <ReactPDF props={ddjj} />
      </PDFViewer>:
      (<div>Error, intente mas tarde.</div>)      
      }
     </div>
  );
}

export default UserDDJJ